// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"d96fbc2a","453":"58e4e544","905":"951ca710"}[chunkId] + ".chunk.js";
};